// extracted by mini-css-extract-plugin
export default {"skillLevelWidget":"styles_skillLevelWidget__sWbkW","chips":"styles_chips__5yDCW"};